(function (global) {
  'use strict';

  var PARAM_NAME = 'category';
  var EVENT_NAME = 'classroom-category:change';
  var TITLE_PLACEHOLDER = /\|\|/g;

  function normalizeSlug(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-');
  }

  function getParamName() {
    var root = global.document.querySelector('[data-classroom-param-name]');
    return (root && root.getAttribute('data-classroom-param-name')) || PARAM_NAME;
  }

  function getCategoryFromUrl() {
    var params = new URLSearchParams(global.location.search);
    return normalizeSlug(params.get(getParamName()));
  }

  function setCategoryInUrl(slug) {
    var params = new URLSearchParams(global.location.search);
    var paramName = getParamName();

    if (!slug) {
      params.delete(paramName);
    } else {
      params.set(paramName, slug);
    }

    var next =
      global.location.pathname +
      (params.toString() ? '?' + params.toString() : '') +
      global.location.hash;

    global.history.replaceState(null, '', next);
  }

  function parseCategories(raw) {
    if (!raw) return [];
    return raw
      .split(',')
      .map(function (item) {
        return normalizeSlug(item);
      })
      .filter(Boolean);
  }

  function tutorialMatchesCategory(tutorial, activeSlug) {
    if (!activeSlug) return true;

    var categories = parseCategories(tutorial.getAttribute('data-categories'));
    if (!categories.length) return true;
    return categories.indexOf(activeSlug) !== -1;
  }

  function isAllCategory(normalized) {
    return !normalized;
  }

  function updateListLayout(list, visibleCount, normalized) {
    var forceHero = !isAllCategory(normalized);
    var layout = (forceHero || visibleCount === 1) ? 'hero' : 'grid';
    list.setAttribute('data-layout', layout);

    var grid = list.querySelector('[data-classroom-grid]');
    var hero = list.querySelector('[data-classroom-hero]');
    var empty = list.querySelector('[data-classroom-empty]');
    var heroNav = list.querySelector('[data-classroom-hero-navigation]');
    let container = list.closest(".classroom-tutorial-groups__inner");
    console.log("container", container);
    if (grid) {
      grid.classList.toggle('is-hidden', layout !== 'grid' || visibleCount === 0);
    }
    if (hero) {
      hero.classList.toggle('is-hidden', layout !== 'hero' || visibleCount === 0);
    }
    if (empty) {
      empty.classList.toggle('is-hidden', visibleCount !== 0);
    } 
    container.classList.toggle('hidden', visibleCount === 0);
    if (heroNav) {
      heroNav.classList.toggle('is-hidden', visibleCount <= 1);
    }
    
    list.classList.toggle('classroom-tutorial-groups__list--empty', visibleCount === 0);

    var countValue = String(visibleCount);
    if (grid) grid.setAttribute('data-tutorials-count', countValue);
    if (hero) hero.setAttribute('data-tutorials-count', countValue);
  }

  function getActiveCategoryLabel() {
    var active = global.document.querySelector(
      '[data-classroom-category-nav] [data-classroom-category-button].is-active'
    );
    if (!active) return '';

    if (active.getAttribute('data-category-all') === 'true') {

      // return 'All';
      return '';
    }

    var label = active.getAttribute('data-category-label');
    return label ? label.trim() : '';
  }

  function resolveHeadingTitle(template, categoryLabel) {
    if (!template) return '';
    if (template.indexOf('||') === -1) return template;
    return template.replace(TITLE_PLACEHOLDER, categoryLabel);
  }

  function updateSectionHeadings() {
    var categoryLabel = getActiveCategoryLabel();

    global.document.querySelectorAll('[data-classroom-heading]').forEach(function (heading) {
      var template = heading.getAttribute('data-classroom-heading-template') || '';
      heading.textContent = resolveHeadingTitle(template, categoryLabel);
    });
  }

  function setTutorialVisibility(tutorialNodes, show) {
    tutorialNodes.forEach(function (node) {
      node.classList.toggle('is-hidden', !show);
      node.classList.toggle('swiper-slide-hidden', !show);
    });
  }

  function applyCategoryFilter(activeSlug) {
    var normalized = normalizeSlug(activeSlug);

    global.document.querySelectorAll('[data-classroom-category-nav]').forEach(function (nav) {
      nav.querySelectorAll('[data-classroom-category-button]').forEach(function (button) {
        var buttonSlug = normalizeSlug(button.getAttribute('data-category-slug'));
        var isAll = button.getAttribute('data-category-all') === 'true';
        var isActive = isAll ? !normalized : buttonSlug === normalized;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    });

    global.document.querySelectorAll('[data-classroom-tutorial-list]').forEach(function (list) {
      var tutorialMap = {};
      var visibleCount = 0;

      list.querySelectorAll('[data-classroom-tutorial]').forEach(function (tutorial) {
        var tutorialId = tutorial.getAttribute('data-tutorial-id');
        if (!tutorialId || tutorialMap[tutorialId]) return;

        var nodes = list.querySelectorAll(
          '[data-classroom-tutorial][data-tutorial-id="' + tutorialId + '"]'
        );
        var show = tutorialMatchesCategory(tutorial, normalized);

        tutorialMap[tutorialId] = show;
        setTutorialVisibility(Array.prototype.slice.call(nodes), show);
        if (show) visibleCount += 1;
      });

      updateListLayout(list, visibleCount, normalized);
      refreshSwipers();
      refreshHeroSwipers();
    });

    updateSectionHeadings();

    global.document.dispatchEvent(
      new CustomEvent(EVENT_NAME, {
        detail: { category: normalized },
      })
    );
  }

  function scrollActiveCategoryIntoView(nav) {
    var active = nav.querySelector('[data-classroom-category-button].is-active');
    if (!active || !nav.querySelector('[data-classroom-category-track]')) return;

    var track = nav.querySelector('[data-classroom-category-track]');
    var trackRect = track.getBoundingClientRect();
    var activeRect = active.getBoundingClientRect();

    if (activeRect.left < trackRect.left) {
      track.scrollTo({ left: active.offsetLeft - 16, behavior: 'smooth' });
    } else if (activeRect.right > trackRect.right) {
      track.scrollTo({
        left: active.offsetLeft - track.clientWidth + active.clientWidth + 16,
        behavior: 'smooth',
      });
    }
  }

  function initCategoryNav(nav) {
    nav.querySelectorAll('[data-classroom-category-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var slug = button.getAttribute('data-category-all') === 'true' ? '' : button.getAttribute('data-category-slug');
        setCategoryInUrl(slug);
        applyCategoryFilter(slug);
        scrollActiveCategoryIntoView(nav);
      });
    });
  }

  function getTutorialsCountFromPanel(panel) {
    if (!panel) return 0;
    var count = parseInt(panel.getAttribute('data-tutorials-count') || '0', 10);
    return isNaN(count) ? 0 : count;
  }

  function destroyHeroSwiper(root) {
    if (!root.classroomHeroSwiper) return;
    root.classroomHeroSwiper.destroy(true, true);
    root.classroomHeroSwiper = null;
    root.classList.remove('is-initialized');
  }

  function destroyClassroomSwiper(root) {
    if (!root.classroomSwiper) return;
    root.classroomSwiper.destroy(true, true);
    root.classroomSwiper = null;
    root.classList.remove('is-initialized');
  }

  function createHeroSwiper(root) {
    if (!global.Swiper) return null;

    var container = root.querySelector('[data-swiper-container]');
    if (!container) return null;

    var prev = root.querySelector('[data-hero-swiper-prev]');
    var next = root.querySelector('[data-hero-swiper-next]');
    var config = {
      slidesPerView: 1.05,
      spaceBetween: 10,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        750: {
          slidesPerView: 1.2,
          spaceBetween: 16,
        }
      },
    };

    if (prev && next) {
      config.navigation = { prevEl: prev, nextEl: next };
    }

    return new global.Swiper(container, config);
  }

  function refreshHeroSwipers() {
    global.document.querySelectorAll('[data-classroom-hero-swiper]').forEach(function (root) {
      var panel = root.closest('[data-classroom-hero]');
      if (!panel || panel.classList.contains('is-hidden')) {
        destroyHeroSwiper(root);
        return;
      }

      if (getTutorialsCountFromPanel(panel) <= 1) {
        destroyHeroSwiper(root);
        return;
      }

      if (!root.classList.contains('is-initialized')) {
        var swiper = createHeroSwiper(root);
        if (!swiper) return;
        root.classroomHeroSwiper = swiper;
        root.classList.add('is-initialized');
        return;
      }

      if (root.classroomHeroSwiper) {
        root.classroomHeroSwiper.update();
        root.classroomHeroSwiper.slideTo(0, 0);
      }
    });
  }

  function createClassroomSwiper(root) {
    if (!global.Swiper) return null;

    var container = root.querySelector('[data-swiper-container]');
    if (!container) return null;

    var prev = root.querySelector('[data-swiper-prev-button]');
    var next = root.querySelector('[data-swiper-next-button]');
    var config = {
      slidesPerView: 1.05,
      spaceBetween: 16,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1000: {
          slidesPerView: 3,

        },
        1500: {
          slidesPerView: 3,
          spaceBetween: 32,

        }
      },
    };

    if (prev && next) {
      config.navigation = { prevEl: prev, nextEl: next };
    }

    return new global.Swiper(container, config);
  }

  function refreshSwipers() {
    global.document.querySelectorAll('[data-classroom-swiper]').forEach(function (root) {
      var panel = root.closest('[data-classroom-grid]');
      if (!panel || panel.classList.contains('is-hidden')) {
        destroyClassroomSwiper(root);
        return;
      }

      if (getTutorialsCountFromPanel(panel) <= 1) {
        destroyClassroomSwiper(root);
        return;
      }

      if (!root.classList.contains('is-initialized')) {
        var swiper = createClassroomSwiper(root);
        if (!swiper) return;
        root.classroomSwiper = swiper;
        root.classList.add('is-initialized');
        return;
      }

      if (root.classroomSwiper) {
        root.classroomSwiper.update();
        root.classroomSwiper.slideTo(0, 0);
      }
    });
  }

  function init() {
    global.document.querySelectorAll('[data-classroom-category-nav]').forEach(initCategoryNav);
    applyCategoryFilter(getCategoryFromUrl());
    global.document.querySelectorAll('[data-classroom-category-nav]').forEach(scrollActiveCategoryIntoView);
  }

  if (global.document.readyState === 'loading') {
    global.document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  global.ClassroomCollection = {
    applyCategoryFilter: applyCategoryFilter,
    getCategoryFromUrl: getCategoryFromUrl,
  };
})(window);
